/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { EvidenceErrors } from './evidence-errors';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceFile } from './evidence-file';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceInvoiceIssuer } from './evidence-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceUpdatedBy } from './evidence-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceUploadedBy } from './evidence-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceWarnings } from './evidence-warnings';

/**
 * 
 * @export
 * @interface Evidence
 */
export interface Evidence {
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'paymentType': EvidencePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'electronicMethod': EvidenceElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'documentSize': EvidenceDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof Evidence
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'legalValidity': EvidenceLegalValidityEnum;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof Evidence
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidenceFile}
     * @memberof Evidence
     */
    'file': EvidenceFile;
    /**
     * 
     * @type {EvidenceInvoiceIssuer}
     * @memberof Evidence
     */
    'invoiceIssuer': EvidenceInvoiceIssuer | null;
    /**
     * 
     * @type {EvidenceErrors}
     * @memberof Evidence
     */
    'errors': EvidenceErrors;
    /**
     * 
     * @type {EvidenceWarnings}
     * @memberof Evidence
     */
    'warnings': EvidenceWarnings;
    /**
     * 
     * @type {EvidenceUpdatedBy}
     * @memberof Evidence
     */
    'updatedBy': EvidenceUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidenceUploadedBy}
     * @memberof Evidence
     */
    'uploadedBy': EvidenceUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof Evidence
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof Evidence
     */
    'needsMigration'?: boolean;
}

export const EvidencePaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidencePaymentTypeEnum = typeof EvidencePaymentTypeEnum[keyof typeof EvidencePaymentTypeEnum];
export const EvidenceElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceElectronicMethodEnum = typeof EvidenceElectronicMethodEnum[keyof typeof EvidenceElectronicMethodEnum];
export const EvidenceDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceDocumentSizeEnum = typeof EvidenceDocumentSizeEnum[keyof typeof EvidenceDocumentSizeEnum];
export const EvidenceLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidenceLegalValidityEnum = typeof EvidenceLegalValidityEnum[keyof typeof EvidenceLegalValidityEnum];


